import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import { AiTopic } from '../../../../../lib/types/AiTypes';
import RobotReply from '../components/Reply/RobotReply';
import PhoneNumberInput from '../components/Input/PhoneNumberInput';
import OptionButton from '../components/Button/OptionButton';
import UserReply from '../components/Reply/UserReply';
import CheckLoading from '../components/Loading/CheckLoading';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import Q5 from '../Q5';
import Q7 from '../Q7';
import Q9 from '../Q9';
import Q18 from '../Q18';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 没有取餐码
 */
const Q4_1: FC<Props> = ({
  cabId,
  h5Platform,
  addElement,
  setTargetPage,
  deviceCode,
  sessionId,
  enterPhoneNumber,
}) => {
  // 选项
  const options: {key: string; zhValue: string; enValue: string}[] = [
    { key: 'phoneNumberInput', zhValue: 'InputBox', enValue: 'InputBox' },
    { key: '18', zhValue: '我没有骑手联系方式', enValue: 'I don’t have driver’s contact number' },
  ];
  // 把选项发送给后台
  const [getH5OrderBoxListByDriverPhone] = getFoodifoxDataLazy<AiTopic>('/fox3PDAi/getH5OrderBoxListByDriverPhone');

  /**
   * 尝试次数增加时，自动追加节点
   */
  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '抱歉，我无法匹配这个手机号。请再试一次。';
    const langEn = 'Sorry, I couldn’t match this phone number. Please try again.';

    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.6) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q4 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          {
            options.map(({ key, zhValue, enValue }) => {
              if (key === 'phoneNumberInput') {
                return (
                  <RowLeft key={key + '' + (new Date().getTime())}>
                    <PhoneNumberInput
                      flowId={flowId}
                      callback={(phoneNumber) => {
                        addSystemLog(cabId, deviceCode, h5Platform + '', 'Q4-1 - user: ' + phoneNumber, sessionId);
                        addElement(
                          <UserReply
                            langZh={phoneNumber}
                            langEn={phoneNumber}
                          />
                        );
                        send(phoneNumber);
                      }}
                    />
                  </RowLeft>
                );
              }
              else {
                return (
                  <RowLeft key={key + '' + (new Date().getTime())}>
                    <OptionButton
                      langZh={(
                        <div style={{ width: 229, textAlign: 'center' }}>
                          {zhValue}
                        </div>
                      )}
                      langEn={(
                        <div style={{ width: 229, textAlign: 'center' }}>
                          {enValue}
                        </div>
                      )}
                      flowId={flowId}
                      callback={() => {
                        addSystemLog(cabId, deviceCode, h5Platform + '', 'Q4-1 - user: ' + enValue, sessionId);
                        addElement(
                          <UserReply
                            langZh={zhValue}
                            langEn={enValue}
                          />
                        );
                        addElement(
                          <Q18
                            cabId={cabId}
                            h5Platform={h5Platform}
                            addElement={addElement}
                            deviceCode={deviceCode}
                            sessionId={sessionId}
                          />
                        );
                      }}
                    />
                  </RowLeft>
                );
              }
            })
          }
        </LeftToRight>
      );
    }, 400);
  }, []);

  /**
   * 发送选项给后台
   * @param phone 输入的手机号码
   */
  const send = (phone: string) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在查询订单…'}
        enText={'Please wait...We are confirming details.'}
        style={{ maxWidth: lang('80%', '100%') }}
      />
    );

    // 发送选项给后台
    getH5OrderBoxListByDriverPhone({
      param: {
        driverPhoneNumber: phone,
        useCabId: cabId,
      },
      onCompleted({ id, boxNumberList: boxList, boxOfflineCode }) {
        setTimeout(() => {
          if (!((boxList || []).length > 0 || (boxOfflineCode || []).length > 0)) {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
          }
        }, 2000);
        setTimeout(() => {
          if ((boxList || []).length === 1 || (boxOfflineCode || []).length === 1) {
            if ((boxList || []).length > 0 && (boxOfflineCode || []).length === 0) {
              addElement(
                <Q7
                  boxList={boxList || []}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  cabId={cabId}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  loadingFlowId={loadingFlowId}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
            else {
              addElement(
                <Q9
                  cabId={cabId}
                  boxList={boxList || []}
                  boxOfflineCode={boxOfflineCode || []}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
          }
          else if ((boxList || []).length > 1 || (boxOfflineCode || []).length > 1) {
            addElement(
              <Q5
                cabId={cabId}
                addElement={addElement}
                h5Platform={h5Platform}
                setTargetPage={setTargetPage}
                deviceCode={deviceCode}
                sessionId={sessionId}
                driverPhone={phone}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
          else {
            addElement(
              <Q4_1
                cabId={cabId}
                addElement={addElement}
                h5Platform={h5Platform}
                setTargetPage={setTargetPage}
                deviceCode={deviceCode}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
        }, 2200);
      },
    });
  };

  return (
    <></>
  );
};

export interface Props {
  addElement: (elements: any) => void;
  cabId: number;
  h5Platform: number;
  setTargetPage: (targetPage: string) => void;
  deviceCode: string;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q4_1;
